import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { iif } from 'rxjs';
import { GLOBAL } from 'src/app/services/global';
import { wsGenerarPDFService } from 'src/app/services/wsGenerarPDF.service';
import { saveAs } from 'file-saver';
declare var $: any;
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-formulario232',
  templateUrl: './formulario232.component.html',
  styleUrls: ['./formulario232.component.css'],
  providers: [wsGenerarPDFService]
})
export class Formulario232Component {
  htmlcanvas: any = html2canvas;
  @ViewChild('dataHtml') dataHtml: ElementRef;

  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public color = "#C6E0B4"
  public data = "variable data del ts"
  pages = [1, 2, 3];

  public tipo_solicitud;
  public cip;
  public registro_bienes;
  public propiedad;
  public propietarios;
  public personeria;
  public representantes;
  public representantePropietario;
  public permiso_notariado;
  public empresas;
  public arquitectos;
  public unidades;
  public condominio;
  public clasificacion;
  public tipo_aprobacion;
  public destino;
  public superficie_anteproyecto;
  public superficieSubterraneo;
  public superficieSobre;
  public superficieDestino;
  public normas_urbanisticas;
  public uso_suelo;
  public porcentajes_obr;
  public protecciones_esp;
  public forma_cumpl;
  public aporte;
  public disposiciones_esp;
  public autorizaciones;
  public anteproy_condominio;
  public condiciones;
  public permiso;
  public otras_solicitudes;
  public permisos_recepciones;
  public recepciones_definitivas;
  public uso_publico;
  public declaracion;
  public calculistas;
  public calculistaProfesional;
  public constructora;
  public constructoraProfesional;
  public inspectorObra;
  public inspectorProfesional;
  public revisor;
  public cuentaRevisor;
  public cuentaRevisorCalculo;
  public revisorCalculo;
  public revisorProfesional;
  public caract_anteproyecto_obranueva;
  public antecedentesPrevios;
  public incentivos;
  public antecedentes;
  public totalUtilSub = 0
  public totalComunSub = 0
  public totalesSub = 0
  public totalUtilSob = 0
  public totalComunSob = 0
  public totalesSob = 0
  public porcentaje_finalCesion;
  public calculoAcumulado;
  public porcentajeTotal_cesiones = 0

   constructor(private spinner: NgxSpinnerService, private _wsGenerarPDFService: wsGenerarPDFService) {

  }

  ngOnInit() {

    /*   $("#planoNo").checked = false; */
    /*  $("#planoNo").attr("checked", true); */
  }

  ngAfterContentChecked() {
    this.ngAfterContentInit();
  }


  ngAfterContentInit() {
    /*  console.log(this.dataHtml.nativeElement.innerHTML); */


    //ANTECEDENTES PREVIOS
    if (JSON.parse(localStorage.getItem("antecedentesPrevios"))) {
      if (JSON.parse(localStorage.getItem("antecedentesPrevios")).length > 0) {
        this.antecedentesPrevios = JSON.parse(localStorage.getItem("antecedentesPrevios"));


        if (this.antecedentesPrevios[0].datosExtrasAntecedentes == "ALTERACIÓN") {
          $("#ALTERACIÓN").attr("checked", true);
        }
        if (this.antecedentesPrevios[0].datosExtrasAntecedentes == "CAMBIO DE DESTINO") {
          $("#CAMBIODESTINO").attr("checked", true);
        }
        if (this.antecedentesPrevios[0].datosExtrasAntecedentes == "DEMOLICIÓN") {
          $("#DEMOLICIÓN").attr("checked", true);
        }
      } else {
        localStorage.setItem("antecedentesPrevios", JSON.stringify([]))
        this.antecedentesPrevios = [{
          datosExtrasAntecedentes: "",
          fechaProyecto: "",
          nombreProyecto: "",
          numeroProyecto: ""
        }]
      }
    }

    //PROPIEDAD
    if (JSON.parse(localStorage.getItem("informacionPropiedad"))) {
      if (JSON.parse(localStorage.getItem("informacionPropiedad")).length > 0) {
        this.propiedad = JSON.parse(localStorage.getItem("informacionPropiedad"));
      } else {
        localStorage.setItem("informacionPropiedad", JSON.stringify([]))
        this.propiedad = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', recordId: '' }]
      }
    }

    //DECLARACION
    if (JSON.parse(localStorage.getItem("declaracion"))) {
      if (JSON.parse(localStorage.getItem("declaracion")).length > 0) {
        this.declaracion = JSON.parse(localStorage.getItem("declaracion"));

        if (this.declaracion[0].plano == "SI") {
          $("#planoSi").attr("checked", true);
        }
        if (this.declaracion[0].plano == "NO") {
          $("#planoNo").attr("checked", true);
        }
      } else {
        localStorage.setItem("declaracion", JSON.stringify([]))
        this.declaracion = [{
          plano: '',
          denominado: '',
          elaborado: '',
          profesion: '',
          forjas: '',
          numero: '',
          ano: '',
          bienesRa: ''
        }]
      }
    }

    //PROPIETARIOS
    if (JSON.parse(localStorage.getItem("propietarios"))) {
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
      } else {
        localStorage.setItem("propietarios", JSON.stringify([]))
        this.propietarios = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }]
      }
    }

    //PERSONERIA
    if (JSON.parse(localStorage.getItem("personeria"))) {
      if (JSON.parse(localStorage.getItem("personeria")).length > 0) {
        this.personeria = JSON.parse(localStorage.getItem("personeria"));
      } else {
        localStorage.setItem("personeria", JSON.stringify([]))
        this.personeria = [{
          aMediante: '',
          aFecha: '',
          escrituraFecha: '',
          notario: '',
          medInstrumento: '',
          oMediante: '',
          oFecha: '',
        }]
      }
    }

    //REPRESENTANTE PROPIETARIO
    if (JSON.parse(localStorage.getItem("propietarioRepresentante"))) {
      if (JSON.parse(localStorage.getItem("propietarioRepresentante")).length > 0) {
        this.representantePropietario = JSON.parse(localStorage.getItem("propietarioRepresentante")); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
      } else {
        localStorage.setItem("propietarioRepresentante", JSON.stringify([]))
        this.representantePropietario = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }]
      }
    }

    //PERMISO NOTARIADO
    /*   if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
        if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0) {
          this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
        } else {
          localStorage.setItem("permiso_notariado", JSON.stringify([]))
          this.permiso_notariado = [{ acreditacion: '', fecha: null, escritura: null, notario: '' }]
        }
      } */

    //EMPRESAS
    if (JSON.parse(localStorage.getItem("empresas"))) {
      if (JSON.parse(localStorage.getItem("empresas")).length > 0) {
        this.empresas = JSON.parse(localStorage.getItem("empresas"))
      } else {
        localStorage.setItem("empresas", JSON.stringify([]))
        this.empresas = [{ rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }]
      }
    }

    //ARQUITECTOS
    if (JSON.parse(localStorage.getItem("arquitectos"))) {
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"))
      } else {
        localStorage.setItem("arquitectos", JSON.stringify([]))
        this.arquitectos = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }]
      }
    }

    //CALCULISTAS
    if (JSON.parse(localStorage.getItem("calculistas"))) {
      if (JSON.parse(localStorage.getItem("calculistas")).length > 0) {
        this.calculistas = JSON.parse(localStorage.getItem("calculistas"))
      } else {
        localStorage.setItem("calculistas", JSON.stringify([]))
        this.calculistas = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }]
      }
    }

    //CALCULISTA PROFESIONAL
    if (JSON.parse(localStorage.getItem("calculistaProfesional"))) {
      if (JSON.parse(localStorage.getItem("calculistaProfesional")).length > 0) {
        this.calculistaProfesional = JSON.parse(localStorage.getItem("calculistaProfesional"))
      } else {
        localStorage.setItem("calculistaProfesional", JSON.stringify([]))
        this.calculistaProfesional = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }]
      }
    }

    //CONSTRUCTOR
    if (JSON.parse(localStorage.getItem("constructora"))) {
      if (JSON.parse(localStorage.getItem("constructora")).length > 0) {
        this.constructora = JSON.parse(localStorage.getItem("constructora"))
      } else {
        localStorage.setItem("constructora", JSON.stringify([]))
        this.constructora = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }]
      }
    }

    //CONSTRUCTOR PROFESIONAL
    if (JSON.parse(localStorage.getItem("constructoraProfesional"))) {
      if (JSON.parse(localStorage.getItem("constructoraProfesional")).length > 0) {
        this.constructoraProfesional = JSON.parse(localStorage.getItem("constructoraProfesional"))
      } else {
        localStorage.setItem("constructoraProfesional", JSON.stringify([]))
        this.constructoraProfesional = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }]
      }
    }

    //INSPECTOR OBRA
    if (JSON.parse(localStorage.getItem("inspectorObra"))) {
      if (JSON.parse(localStorage.getItem("inspectorObra")).length > 0) {
        this.inspectorObra = JSON.parse(localStorage.getItem("inspectorObra"))
        if (this.inspectorObra[0].rut != "") {
          $("#cuentaInspectorSI").attr("checked", true);
          $("#cuentaInspectorNO").attr("checked", false);
        } else {
          $("#cuentaInspectorSI").attr("checked", false);
          $("#cuentaInspectorNO").attr("checked", true);
        }
      } else {
        localStorage.setItem("inspectorObra", JSON.stringify([]))
        this.inspectorObra = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }]
      }
    }

    //INSPECTOR OBRA PROFESIONAL
    if (JSON.parse(localStorage.getItem("inspectorProfesional"))) {
      if (JSON.parse(localStorage.getItem("inspectorProfesional")).length > 0) {
        this.inspectorProfesional = JSON.parse(localStorage.getItem("inspectorProfesional"))
      } else {
        localStorage.setItem("inspectorProfesional", JSON.stringify([]))
        this.inspectorProfesional = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }]
      }
    }

    //CUENTA CON REVISOR
    if (JSON.parse(localStorage.getItem("cuentaRevisor"))) {
      if (JSON.parse(localStorage.getItem("cuentaRevisor")).length > 0) {
        this.cuentaRevisor = JSON.parse(localStorage.getItem("cuentaRevisor"))
        if (this.cuentaRevisor[0].informe == "SI") {
          $("#revisorSi").attr("checked", true);
        }
        if (this.cuentaRevisor[0].informe == "NO") {
          $("#revisorNo").attr("checked", true);
        }
      } else {
        localStorage.setItem("cuentaRevisor", JSON.stringify([]))
        this.cuentaRevisor = [{ informe: '', numero: '', fecha: '' }]
      }
    }

    // REVISOR INDEPENDIENTE
    if (JSON.parse(localStorage.getItem("revisor"))) {
      if (JSON.parse(localStorage.getItem("revisor")).length > 0) {
        this.revisor = JSON.parse(localStorage.getItem("revisor"))
      } else {
        localStorage.setItem("revisor", JSON.stringify([]))
        this.revisor = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' }]
      }
    }

    // CUENTA CON REVISOR CALCULO
    if (JSON.parse(localStorage.getItem("cuentaRevisorCalculo"))) {


      if (JSON.parse(localStorage.getItem("cuentaRevisorCalculo")).length > 0) {
        this.cuentaRevisorCalculo = JSON.parse(localStorage.getItem("cuentaRevisorCalculo"))
        if (this.cuentaRevisorCalculo[0].informe == "SI") {
          $("#revisorCalSi").attr("checked", true);
        }
        if (this.cuentaRevisorCalculo[0].informe == "NO") {
          $("#revisorCalNo").attr("checked", true);
        }
      } else {
        localStorage.setItem("cuentaRevisorCalculo", JSON.stringify([]))
        this.cuentaRevisorCalculo = [{
          informe: '',
          numero: '',
          fecha: '',
        }]
      }
    }

    // REVISOR CALCULO ESTRUCTURAL
    if (JSON.parse(localStorage.getItem("revisorCalculo"))) {
      if (JSON.parse(localStorage.getItem("revisorCalculo")).length > 0) {
        this.revisorCalculo = JSON.parse(localStorage.getItem("revisorCalculo"))
      } else {
        localStorage.setItem("revisorCalculo", JSON.stringify([]))
        this.revisorCalculo = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }]
      }
    }

    // REVISOR PROFESIONAL
    if (JSON.parse(localStorage.getItem("revisorProfesional"))) {
      if (JSON.parse(localStorage.getItem("revisorProfesional")).length > 0) {
        this.revisorProfesional = JSON.parse(localStorage.getItem("revisorProfesional"))
      } else {
        localStorage.setItem("revisorProfesional", JSON.stringify([]))
        this.revisorProfesional = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }]
      }
    }

    // Características Principales 
    if (JSON.parse(localStorage.getItem("caract_anteproyecto_obranueva"))) {
      if (JSON.parse(localStorage.getItem("caract_anteproyecto_obranueva")).length > 0) {
        this.caract_anteproyecto_obranueva = JSON.parse(localStorage.getItem("caract_anteproyecto_obranueva"))


        if (this.caract_anteproyecto_obranueva[0].anteProyectoAprobado == "NO") {
          $("#anteproyectoNo").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].anteProyectoAprobado == "SI") {
          $("#anteproyectoSi").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].edificio_usoPublico == "todo") {
          $("#edificioDeUsoTodo").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].edificio_usoPublico == "parte") {
          $("#edificioUsoParte").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].edificio_usoPublico == "no es edificio de uso público") {
          $("#edificioUsoNoEdificio").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].crecimientoUrbano == "NO") {
          $("#noCrecimiento").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].crecimientoUrbano == "SI") {
          $("#siCrecimiento").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].proyecto_etapas == "no") {
          $("#noProyectoEtapas").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].proyecto_etapas == "si") {
          $("#siProyectoEtapas").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].loteo_construccion == "no") {
          $("#noLoteoConst").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].loteo_construccion == "si") {
          $("#siLoteoConst").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].loteo_dfl == "no") {
          $("#noLoteoDfl").attr("checked", true);
        }
        if (this.caract_anteproyecto_obranueva[0].loteo_dfl == "si") {
          $("#siLoteoDfl").attr("checked", true);
        }

      } else {
        localStorage.setItem("caract_anteproyecto_obranueva", JSON.stringify([]))
        this.caract_anteproyecto_obranueva = [
          {
            anteProyectoAprobado: "",
            anteProyectoAprobadoFecha: "",
            anteProyectoAprobadoRes: "",
            cantidad_etapas: "",
            carga_ocupacionTotal: "",
            carga_ocupacionTotalReconstruccion: "",
            crecimientoUrbano: "",
            densidadOcupacion: "",
            densidadOcupacionReconstruccion: "",
            edificio_usoPublico: "",
            etapas_art9: "",
            etapas_mitigaciones: "",
            explicitar: "",
            fecha_permiso: "",
            fecha_recepcion: "",
            loteo_construccion: "",
            loteo_dfl: "",
            num_permiso: "",
            num_recepcion: "",
            proyecto_etapas: "",
            tipoAlteracion: "",
            tipoResRebReh: "",
            tipoResRebRehOtro: "",
            tipoSupresion: "",
            tipo_permiso: "",
            tipo_recepcion: "",
            tipo_reconstruccion: ""
          }
        ]
      }
    }

    // SUPERFICIE 
    if (JSON.parse(localStorage.getItem("superficie_anteproyecto"))) {
      if (JSON.parse(localStorage.getItem("superficie_anteproyecto")).length > 0) {
        this.superficie_anteproyecto = JSON.parse(localStorage.getItem("superficie_anteproyecto"))
      } else {
        localStorage.setItem("superficie_anteproyecto", JSON.stringify([]))
        this.superficie_anteproyecto = [
          {
            comun1: "",
            comun1Ampliacion: "",
            comun1Final: "",
            comun2: "",
            comun2Ampliacion: "",
            comun2Final: "",
            comun3: "",
            comun3Ampliacion: "",
            comun3Final: "",
            rec_mantienePermiso: "",
            superficieOcupacion: "",
            superficieOcupacionTotal: "",
            superficieTotal: "",
            total1: "",
            total1Ampliacion: "",
            total1Final: "",
            total2: "",
            total2Ampliacion: "",
            total2Final: "",
            total3: "",
            total3Ampliacion: "",
            total3Final: "",
            util1: "",
            util1Ampliacion: "",
            util1Final: "",
            util2: "",
            util2Ampliacion: "",
            util2Final: "",
            util3: "",
            util3Ampliacion: "",
            util3Final: ""
          }]
      }
    }

    // SUPERFICIE SUBTERRANEO


    if (JSON.parse(localStorage.getItem("superficieSubterraneo"))) {
      if (JSON.parse(localStorage.getItem("superficieSubterraneo")).length > 0) {
        this.superficieSubterraneo = JSON.parse(localStorage.getItem("superficieSubterraneo"))

        let auxUtil = 0
        let auxComun = 0
        let auxTotales = 0

        for (let i = 0; i < this.superficieSubterraneo.length; i++) {
          const element = this.superficieSubterraneo[i];
          auxUtil = auxUtil + (element.utilSub)
          auxComun = auxComun + (element.comunSub)
          auxTotales = auxTotales + (element.totalSub)
        }


        this.totalUtilSub = auxUtil
        this.totalComunSub = auxComun
        this.totalesSub = auxTotales

        // console.log("valores totales: ", this.totalUtil, this.totalComun, this.totales);

      } else {
        localStorage.setItem("superficieSubterraneo", JSON.stringify([]))
        this.superficieSubterraneo = [
          {
            nivelSub: "",
            utilSub: "",
            comunSub: "",
            totalSub: ""
          }]
      }
    }

    // SUPERFICIE SOBRE
    if (JSON.parse(localStorage.getItem("superficieSobre"))) {
      if (JSON.parse(localStorage.getItem("superficieSobre")).length > 0) {
        this.superficieSobre = JSON.parse(localStorage.getItem("superficieSobre"))


        let auxUtil = 0
        let auxComun = 0
        let auxTotales = 0

        for (let i = 0; i < this.superficieSobre.length; i++) {
          const element = this.superficieSobre[i];
          auxUtil = auxUtil + (element.utilSub)
          auxComun = auxComun + (element.comunSub)
          auxTotales = auxTotales + (element.totalSub)
        }


        this.totalUtilSob = auxUtil
        this.totalComunSob = auxComun
        this.totalesSob = auxTotales

      } else {
        localStorage.setItem("superficieSobre", JSON.stringify([]))
        this.superficieSobre = [
          {
            nivelSub: "",
            utilSub: "",
            comunSub: "",
            totalSub: ""
          }]
      }
    }


    // SUPERFICIE DESTINO
    if (JSON.parse(localStorage.getItem("superficieDestino"))) {
      if (JSON.parse(localStorage.getItem("superficieDestino")).length > 0) {
        this.superficieDestino = JSON.parse(localStorage.getItem("superficieDestino"))
      } else {
        localStorage.setItem("superficieDestino", JSON.stringify([]))
        this.superficieDestino = [
          {
            residencial: "",
            equipamiento: "",
            actProductivas: "",
            infraestructura: "",
            areaVerde: "",
            espacioPublico: ""
          }]
      }
    }


    // NORMAS URBANÍSTICAS
    if (JSON.parse(localStorage.getItem("normas_urbanisticas"))) {
      if (JSON.parse(localStorage.getItem("normas_urbanisticas")).length > 0) {
        this.normas_urbanisticas = JSON.parse(localStorage.getItem("normas_urbanisticas"))
        if (this.normas_urbanisticas[0].predioEmplazadoArea == "no") {
          $("#noPredioEmplazado").attr("checked", true);
        }
        if (this.normas_urbanisticas[0].predioEmplazadoArea == "si") {
          $("#siPredioEmplazado").attr("checked", true);
        }
        if (this.normas_urbanisticas[0].predioEmplazadoArea == "parcial") {
          $("#parcialPredioEmplazado").attr("checked", true);
        }
        if (this.normas_urbanisticas[0].descuento_Est == "SI") {
          $("#sidescuentoPermisoAnterior").attr("checked", true);
        }
        if (this.normas_urbanisticas[0].descuento_Est == "NO") {
          $("#nodescuentoPermisoAnterior").attr("checked", true);
        }
        if (this.normas_urbanisticas[0].descuento_EstIncluido == "SI") {
          $("#sidescuentoIncluido").attr("checked", true);
        }
        if (this.normas_urbanisticas[0].descuento_EstIncluido == "NO") {
          $("#nodescuentoIncluido").attr("checked", true);
        }
      } else {
        localStorage.setItem("normas_urbanisticas", JSON.stringify([]))
        this.normas_urbanisticas = [
          {
            predioEmplazadoArea: "",

            /* densidad */
            densid_Proyectada_Permiso: "",
            densid_Permitido_Norma: "",
            densid_Ampliacion_Alteracion: "",
            densid_Total_Proyecto: "",
            /* COEFICIENTE DE OCUPACIÓN PISOS SUPERIORES (sobre 1er piso) */
            coefPisos_Proyectada_Permiso: "",
            coefPisos_Permitido_Norma: "",
            coefPisos_Ampliacion_Alteracion: "",
            coefPisos_Total_Proyecto: "",
            /* COEFICIENTE DE OCUPACIÓN DE SUELO (1er piso) */
            coefSuelo_Proyectada_Permiso: "",
            coefSuelo_Permitido_Norma: "",
            coefSuelo_Ampliacion_Alteracion: "",
            coefSuelo_Total_Proyecto: "",
            /* COEFICIENTE DE CONSTRUCTIBILIDAD */
            coefConstr_Proyectada_Permiso: "",
            coefConstr_Permitido_Norma: "",
            coefConstr_Ampliacion_Alteracion: "",
            coefConstr_Total_Proyecto: "",
            /* DISTANCIAMIENTOS */
            distanciamientos_Proyectada_Permiso: "",
            distanciamientos_Permitido_Norma: "",
            distanciamientos_Ampliacion_Alteracion: "",
            distanciamientos_Total_Proyecto: "",
            /* RASANTE */
            rasante_Proyectada_Permiso: "",
            rasante_Permitido_Norma: "",
            rasante_Ampliacion_Alteracion: "",
            rasante_Total_Proyecto: "",
            /* SISTEMA DE AGRUPAMIENTO */
            agrupamiento_Proyectada_Permiso: "",
            agrupamiento_Permitido_Norma: "",
            agrupamiento_Ampliacion_Alteracion: "",
            agrupamiento_Total_Proyecto: "",
            /* ADOSAMIENTO */
            adosamiento_Proyectada_Permiso: "",
            adosamiento_Permitido_Norma: "",
            adosamiento_Ampliacion_Alteracion: "",
            adosamiento_Total_Proyecto: "",
            /* ANTEJARDÍN */
            antejardin_Proyectada_Permiso: "",
            antejardin_Permitido_Norma: "",
            antejardin_Ampliacion_Alteracion: "",
            antejardin_Total_Proyecto: "",
            /* ALTURA EN METROS Y/O PISOS */
            altura_Proyectada_Permiso: "",
            altura_Permitido_Norma: "",
            altura_Ampliacion_Alteracion: "",
            altura_Total_Proyecto: "",
            /* ESTACIONAMIENTOS AUTOMÓVILES */
            automoviles_Proyectada_Permiso: "",
            automoviles_Permitido_Norma: "",
            automoviles_Ampliacion_Alteracion: "",
            automoviles_Total_Proyecto: "",
            /* ESTACIONAMIENTOS BICICLETAS */
            bicicletas_Proyectada_Permiso: "",
            bicicletas_Permitido_Norma: "",
            bicicletas_Ampliacion_Alteracion: "",
            bicicletas_Total_Proyecto: "",
            /* ESTACIONAMIENTOS OTROS VEHÍCULOS (ESPECIFICAR */
            otrosVehiculos_Especificar: "", //especificar
            otrosVehiculos_Proyectada_Permiso: "",
            otrosVehiculos_Permitido_Norma: "",
            otrosVehiculos_Ampliacion_Alteracion: "",
            otrosVehiculos_Total_Proyecto: "",
            /* ESTACIONAMIENTOS PARA PERSONAS CON DISCAPACIDAD */
            personasDiscapacidad_Proyectada_Permiso: "",
            personasDiscapacidad_Permitido_Norma: "",
            personasDiscapacidad_Ampliacion_Alteracion: "",
            personasDiscapacidad_Total_Proyecto: "",
            /* DESCUENTO ESTACIONAMIENTO PARA AUTOMÓVILES POR
            ESTACIONAMIENTO PARA BICICLETAS  o  (PERMISO(S) ANTERIOR(ES))*/
            descuento_Est: "",
            descuento_EstCant: "",
            /* DESCUENTO ESTACIONAMIENTO PARA AUTOMOVILES POR
            ESTACIONAMIENTO PARA BICICLETAS INCLUIDO PROYECTO */
            descuento_EstIncluido: "",
            descuento_EstIncluidoCant: "",
          }]
      }
    }


    // USO DE SUELO
    if (JSON.parse(localStorage.getItem("uso_suelo"))) {
      if (JSON.parse(localStorage.getItem("uso_suelo")).length > 0) {
        this.uso_suelo = JSON.parse(localStorage.getItem("uso_suelo"))
      } else {
        localStorage.setItem("uso_suelo", JSON.stringify([]))
        this.uso_suelo = [
          {
            clase1_residencial: "",
            clase1_equipamiento: "",
            clase1_productivas: "",
            clase1_infraestructura: "",
            clase1_areaVerde: "",
            clase1_espacioPublica: "",

            clase2_residencial: "",
            clase2_equipamiento: "",
            clase2_productivas: "",
            clase2_infraestructura: "",
            clase2_areaVerde: "",
            clase2_espacioPublica: "",

            actividad1_equipamiento: "",
            actividad2_equipamiento: "",

            escala1_equipamiento: "",
            escala2_equipamiento: "",
          }]
      }
    }

    // PROTECCIONES OFICIALES
    if (JSON.parse(localStorage.getItem("protecciones_esp"))) {
      if (JSON.parse(localStorage.getItem("protecciones_esp")).length > 0) {
        this.protecciones_esp = JSON.parse(localStorage.getItem("protecciones_esp"))

        if (this.protecciones_esp[0].prot_NO != "") {
          $("#proteccionNO").attr("checked", this.protecciones_esp[0].prot_NO);
        }
        if (this.protecciones_esp[0].prot_SI != "") {
          $("#proteccionSI").attr("checked", this.protecciones_esp[0].prot_SI);
        }
        if (this.protecciones_esp[0].prot_ZCH != "") {
          $("#proteccionZCH").attr("checked", this.protecciones_esp[0].prot_ZCH);
        }
        if (this.protecciones_esp[0].prot_ICH != "") {
          $("#proteccionICH").attr("checked", this.protecciones_esp[0].prot_ICH);
        }
        if (this.protecciones_esp[0].prot_ZOIT != "") {
          $("#proteccionZOIT").attr("checked", this.protecciones_esp[0].prot_ZOIT);
        }
        if (this.protecciones_esp[0].prot_OTRO != "") {
          $("#proteccionOtro").attr("checked", this.protecciones_esp[0].prot_OTRO);
        }
        if (this.protecciones_esp[0].prot_Monumento != "") {
          $("#proteccionMonumento").attr("checked", this.protecciones_esp[0].prot_Monumento);
        }
        if (this.protecciones_esp[0].prot_ZT != "") {
          $("#proteccionZT").attr("checked", this.protecciones_esp[0].prot_ZT);
        }
        if (this.protecciones_esp[0].prot_MH != "") {
          $("#proteccionMH").attr("checked", this.protecciones_esp[0].prot_MH);
        }
        if (this.protecciones_esp[0].prot_Santuatio != "") {
          $("#proteccionSantuario").attr("checked", this.protecciones_esp[0].prot_Santuatio);
        }

      } else {
        localStorage.setItem("protecciones_esp", JSON.stringify([]))
        this.protecciones_esp = [
          {
            prot_NO: "",
            prot_ZCH: "",
            prot_ICH: "",
            prot_ZOIT: "",
            prot_ZT: "",
            prot_MH: "",
            prot_Monumento: "",
            prot_Santuatio: "",
            prot_SI: "",
            prot_OTRO: "",
            prot_oficial_esp: "",
          }]
      }
    }


    // FORMA DE CUMPLIMIENTO
    if (JSON.parse(localStorage.getItem("forma_cumpl"))) {
      if (JSON.parse(localStorage.getItem("forma_cumpl")).length > 0) {
        this.forma_cumpl = JSON.parse(localStorage.getItem("forma_cumpl"))

        if (this.forma_cumpl[0].forma_cumpl == "Cesion") {
          $("#formaCesion").attr("checked", true);
        }
        if (this.forma_cumpl[0].forma_cumpl == "Aporte") {
          $("#formaAporte").attr("checked", true);
        }
        if (this.forma_cumpl[0].forma_cumpl == "Otro, específicar") {
          $("#formaOtro").attr("checked", true);
        }


      } else {
        localStorage.setItem("forma_cumpl", JSON.stringify([]))
        this.forma_cumpl = [
          {
            forma_cumpl: "",
            forma_cumpl_esp: "",
          }]
      }
    }

    // CALCULO APORTE
    if (JSON.parse(localStorage.getItem("aporte"))) {
      if (JSON.parse(localStorage.getItem("aporte")).length > 0) {
        this.aporte = JSON.parse(localStorage.getItem("aporte"))
      } else {
        localStorage.setItem("aporte", JSON.stringify([]))
        this.aporte = [
          {
            aporteEquivalente: "",
            avaluoIncremento: "",
            avaluoVigente: "",
            cesion: "",
            porcentaje: "",
          }]
      }
    }

    // CÁLCULO PRELIMINAR DEL PORCENTAJE
    if (JSON.parse(localStorage.getItem("porcentajes_obr"))) {
      if (JSON.parse(localStorage.getItem("porcentajes_obr")).length > 0) {
        this.porcentajes_obr = JSON.parse(localStorage.getItem("porcentajes_obr"))

        if (this.porcentajes_obr[0].proy_densidad == "CON DENSIDAD DE OCUPACIÓN HASTA 8.000 Personas/Hectárea") {
          $("#calculoHasta").attr("checked", true);
        }
        if (this.porcentajes_obr[0].proy_densidad == "CON DENSIDAD DE OCUPACIÓN SOBRE 8.000 Personas/Hectárea") {
          $("#calculoSobre").attr("checked", true);
        }



      } else {
        localStorage.setItem("porcentajes_obr", JSON.stringify([]))
        this.porcentajes_obr = [
          {
            densidad_ocupacion: "",
            porcentaje_cesion: "",
            proy_densidad: "",
          }]
      }
    }

    //PORCENTAJE FINAL DE CESIÓN

    if (JSON.parse(localStorage.getItem("porcentaje_finalCesion"))) {
      if (JSON.parse(localStorage.getItem("porcentaje_finalCesion")).length > 0) {
        this.porcentaje_finalCesion = JSON.parse(localStorage.getItem("porcentaje_finalCesion"))

      } else {
        localStorage.setItem("porcentaje_finalCesion", JSON.stringify([]))
        this.porcentaje_finalCesion = [
          {
            porcentajeFinal: "",
          }]
      }
    }
    //CÁLCULO ACUMULADO CON CESIONES
    if (JSON.parse(localStorage.getItem("calculoAcumulado"))) {
      if (JSON.parse(localStorage.getItem("calculoAcumulado")).length > 0) {
        this.calculoAcumulado = JSON.parse(localStorage.getItem("calculoAcumulado"))
        /*    console.log(this.permisos_recepciones); */

        let auxPorcentaje = (this.calculoAcumulado[0].porcentajeN1) + (this.calculoAcumulado[0].porcentajeN2) + (this.calculoAcumulado[0].porcentajeN3)
        this.porcentajeTotal_cesiones = auxPorcentaje.toFixed(2); // Limitar a 2 decimales

      } else {
        localStorage.setItem("calculoAcumulado", JSON.stringify([]))
        this.calculoAcumulado = [
          {
            permisoN1: "",
            permisoN2: "",
            fechaN1: "",
            fechaN2: "",
            porcentajeN1: 0,
            porcentajeN2: 0,
            porcentajeN3: 0,

          },
        ]
      }
    }
    // INCENTIVOS NORMATIVOS
    if (JSON.parse(localStorage.getItem("incentivos"))) {
      if (JSON.parse(localStorage.getItem("incentivos")).length > 0) {
        this.incentivos = JSON.parse(localStorage.getItem("incentivos"))

      } else {
        localStorage.setItem("incentivos", JSON.stringify([]))
        this.incentivos = [
          {
            beneficio: "",
            condicion: "",
          }]
      }
    }

    // DISPOSICIONES ESPECIALES
    if (JSON.parse(localStorage.getItem("disposiciones_esp"))) {
      if (JSON.parse(localStorage.getItem("disposiciones_esp")).length > 0) {
        this.disposiciones_esp = JSON.parse(localStorage.getItem("disposiciones_esp"))
        if (this.disposiciones_esp[0].disposicion1 == true) {
          $("#disposicion1").attr("checked", true);
        }
        /*   if (this.disposiciones_esp[0].disposicion5 == true) {
            $("#disposicion5").attr("checked", true);
          } */
        if (this.disposiciones_esp[0].disposicion3 == true) {
          $("#disposicion3").attr("checked", true);
        }
        if (this.disposiciones_esp[0].disposicion4 == true) {
          $("#disposicion4").attr("checked", true);
        }
        if (this.disposiciones_esp[0].disposicion2 == true) {
          $("#disposicion2").attr("checked", true);
        }
        /*   if (this.disposiciones_esp[0].disposicion6 == true) {
            $("#disposicion6").attr("checked", true);
          } */
        if (this.disposiciones_esp[0].disposicion7 == true) {
          $("#disposicion7").attr("checked", true);
        }
        if (this.disposiciones_esp[0].disposicion8 == true) {
          $("#disposicion8").attr("checked", true);
        }
        if (this.disposiciones_esp[0].disposicion9 == true) {
          $("#disposicion9").attr("checked", true);
        }
        if (this.disposiciones_esp[0].disposicion10 == true) {
          $("#disposicion10").attr("checked", true);
        }
      } else {
        localStorage.setItem("disposiciones_esp", JSON.stringify([]))
        this.disposiciones_esp = [
          {
            disposicion1: "", //D.F.L N2 de 1959
            disposicion2: "", //Ley 19.537 Copropiedad  Inmobiliaria
            disposicion3: "", //Proyeccion Sombras Art 2.6.11 OGUC
            disposicion4: "", //Segunda Vivienda Art 6.2.4 OGUC
            disposicion5: "", //Conjunto Armonico
            disposicion6: "", //Beneficio Fusión Art 63 LGUC
            disposicion7: "", //Conj. Viv Econ Art 6.1.8 OGUC
            disposicion8: "", //Art. 2.4.1. OGUC Inciso Segundo
            disposicion9: "", //Art. 6.6.1. OGUC, según resolución
            disposicion10: "", // Otro (Especificar)
            numero_resolucion: "",
            fecha: "",
            vigente: "",
            especificar: "",
          }]
      }
    }

    // Autorizaciones Especiales
    if (JSON.parse(localStorage.getItem("autorizaciones"))) {
      if (JSON.parse(localStorage.getItem("autorizaciones")).length > 0) {
        this.autorizaciones = JSON.parse(localStorage.getItem("autorizaciones"))
        if (this.autorizaciones[0].Art55 == true) {
          $("#aArt55").attr("checked", true);
        }
        if (this.autorizaciones[0].Art59 == true) {
          $("#aArt59").attr("checked", true);
        }
        if (this.autorizaciones[0].Art121 == true) {
          $("#aArt121").attr("checked", true);
        }
        if (this.autorizaciones[0].Art122 == true) {
          $("#aArt122").attr("checked", true);
        }
        if (this.autorizaciones[0].Art123 == true) {
          $("#aArt123").attr("checked", true);
        }
        if (this.autorizaciones[0].Art124 == true) {
          $("#aArt124").attr("checked", true);
        }
        if (this.autorizaciones[0].Otro == true) {
          $("#aOtro").attr("checked", true);
        }
      } else {
        localStorage.setItem("autorizaciones", JSON.stringify([]))
        this.autorizaciones = [
          {
            Art55: "",
            Art59: "",
            Art121: "",
            Art122: "",
            Art123: "",
            Art124: "",
            Otro: "",
            especificar: "",
          }]
      }
    }

    //  NÚMERO DE UNIDADES
    if (JSON.parse(localStorage.getItem("unidades"))) {
      if (JSON.parse(localStorage.getItem("unidades")).length > 0) {
        this.unidades = JSON.parse(localStorage.getItem("unidades"))

      } else {
        localStorage.setItem("unidades", JSON.stringify([]))
        this.unidades = [
          {
            bodega: 0,
            cantidad: 0,
            est_autos: 0,
            est_bicis: 0,
            locales: 0,
            oficinas: 0,
            otros: 0,
            total: 0,
            vivienda: 0,
            otrosEsp: 0,
            otrosCant: 0,
            otrosEsp2: 0,
            otrosCant2: 0,
          }]
      }
    }


    //para proyectos condominio tipo b
    if (JSON.parse(localStorage.getItem("condominio"))) {
      if (JSON.parse(localStorage.getItem("condominio")).length > 0) {
        this.condominio = JSON.parse(localStorage.getItem("condominio"))

      } else {
        localStorage.setItem("condominio", JSON.stringify([]))
        this.condominio = [
          {
            cant_sitios: "",
            sup_total: "",
          },
        ]
      }
    }

    //  CLASIFICACIÓN(ES) CONSTRUCCIÓN
    if (JSON.parse(localStorage.getItem("clasificacion"))) {
      if (JSON.parse(localStorage.getItem("clasificacion")).length > 0) {
        this.clasificacion = JSON.parse(localStorage.getItem("clasificacion"))

      } else {
        localStorage.setItem("clasificacion", JSON.stringify([]))
        this.clasificacion = [
          {
            clasificacion: "",
            metro: "",
          },
        ]
      }
    }

    //  permisos
    if (JSON.parse(localStorage.getItem("permisos_recepciones"))) {
      if (JSON.parse(localStorage.getItem("permisos_recepciones")).length > 0) {
        this.permisos_recepciones = JSON.parse(localStorage.getItem("permisos_recepciones"))
        /*    console.log(this.permisos_recepciones); */

      } else {
        localStorage.setItem("permisos_recepciones", JSON.stringify([]))
        this.permisos_recepciones = [
          {
            tipo_permiso: '', numero_permiso: '', fecha_permiso: ''
          },
        ]
      }
    }
    //  recepciones definitiva
    if (JSON.parse(localStorage.getItem("recepciones_definitivas"))) {
      if (JSON.parse(localStorage.getItem("recepciones_definitivas")).length > 0) {
        this.recepciones_definitivas = JSON.parse(localStorage.getItem("recepciones_definitivas"))
        /*    console.log(this.permisos_recepciones); */

      } else {
        localStorage.setItem("recepciones_definitivas", JSON.stringify([]))
        this.recepciones_definitivas = [
          {
            tipo_recepcion: '', numero_recepcion: '', fecha_recepcion: ''
          },
        ]
      }
    }

    //7 Otras solicitudes
    if (JSON.parse(localStorage.getItem("otras_solicitudes"))) {
      if (JSON.parse(localStorage.getItem("otras_solicitudes")).length > 0) {
        this.otras_solicitudes = JSON.parse(localStorage.getItem("otras_solicitudes"))
        if (this.otras_solicitudes[0].demolicion == true) {
          $("#odemolicion").attr("checked", true);
        }
        if (this.otras_solicitudes[0].instalacion == true) {
          $("#oinstalacion").attr("checked", true);
        }
        if (this.otras_solicitudes[0].instalacionGruas == true) {
          $("#oinstalacionGruas").attr("checked", true);
        }
        if (this.otras_solicitudes[0].ejecucion == true) {
          $("#oejecucion").attr("checked", true);
        }

        if (this.otras_solicitudes[0].otras == true) {
          $("#ootras").attr("checked", true);
        }
      } else {
        localStorage.setItem("otras_solicitudes", JSON.stringify([]))
        this.otras_solicitudes = [
          {
            demolicion: "",
            instalacion: "",
            instalacionGruas: "",
            ejecucion: "",
            otras: "",
            especificar: "",
            solicitud1: "",
            solicitud2: "",
            solicitud3: "",
            solicitud4: "",
            fecha1: "",
            fecha2: "",
            fecha3: "",
            fecha4: ""
          }]
      }
    }


    //7.1. TRAMITACIÓN PREVIA
    if (JSON.parse(localStorage.getItem("condiciones"))) {
      if (JSON.parse(localStorage.getItem("condiciones")).length > 0) {
        this.condiciones = JSON.parse(localStorage.getItem("condiciones"))
        if (this.condiciones[0].fusion == true) {
          $("#cfusion").attr("checked", true);
        }
        if (this.condiciones[0].subdivision == true) {
          $("#csubdivision").attr("checked", true);
        }
        if (this.condiciones[0].loteo == true) {
          $("#cloteo").attr("checked", true);
        }
        if (this.condiciones[0].sub_afecta == true) {
          $("#csub_afecta").attr("checked", true);
        }
        if (this.condiciones[0].est_medidas == true) {
          $("#cest_medidas").attr("checked", true);
        }
        if (this.condiciones[0].rectificacion == true) {
          $("#crectificacion").attr("checked", true);
        }
        if (this.condiciones[0].modificacion == true) {
          $("#cmodificacion").attr("checked", true);
        }
        if (this.condiciones[0].otros == true) {
          $("#cotros").attr("checked", true);
        }
      } else {
        localStorage.setItem("condiciones", JSON.stringify([]))
        this.condiciones = [
          {
            fusion: "",
            subdivision: "",
            loteo: "",
            sub_afecta: "",
            est_medidas: "",
            rectificacion: "",
            modificacion: "",
            otros: "",
            especificar: "",
            solicitud1: "",
            solicitud2: "",
            solicitud3: "",
            fecha1: "",
            fecha2: "",
            fecha3: ""
          }]
      }
    }

    //7.2. permisos tramitados
    if (JSON.parse(localStorage.getItem("permiso"))) {
      if (JSON.parse(localStorage.getItem("permiso")).length > 0) {
        this.permiso = JSON.parse(localStorage.getItem("permiso"))
        if (this.permiso[0].demolicion == true) {
          $("#pdemolicion").attr("checked", true);
        }

        if (this.permiso[0].otrosEsp == true) {
          $("#potros").attr("checked", true);
        }
      } else {
        localStorage.setItem("permiso", JSON.stringify([]))
        this.permiso = [
          {
            demolicion: "",
            otrosEsp: "",
            especificar: "",
            solicitud1: "",
            solicitud2: "",
            solicitud3: "",
            fecha1: "",
            fecha2: "",
            fecha3: ""
          }]
      }
    }


    //  ANTECEDENTES QUE SE ADJUNTAN
    if (JSON.parse(localStorage.getItem("antecedentes"))) {
      if (JSON.parse(localStorage.getItem("antecedentes")).length > 0) {
        this.antecedentes = JSON.parse(localStorage.getItem("antecedentes"))

        for (let ant = 0; ant < this.antecedentes.length; ant++) {
          const filaAnt = this.antecedentes[ant];

          if (filaAnt) {
            var aux = "#" + filaAnt.id

            $(aux).attr("checked", true);
          }
        }

      } else {
        localStorage.setItem("antecedentes", JSON.stringify([]))
        this.antecedentes = []
      }
    }

  }

  DescargarPdf() {
    this.spinner.show()
    console.log("entre");

    this._wsGenerarPDFService.getBase64(this.dataHtml.nativeElement.innerHTML, this.color).subscribe(response => {
      console.log("response", response);
    
      let blob = this.convertBase64ToBlobData(response.data);
      let title = localStorage.getItem("formTitle") + ".pdf"
      saveAs(blob, title);
      this.spinner.hide();
    }, error => {
      console.log("error", error);
    })
  }


  convertBase64ToBlobData(base64Data: string, contentType: string = 'image/png', sliceSize = 512) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
